enum CompressionDialogFields {
	STREAM_SIZE = "stream_size"
}

export default CompressionDialogFields;